import axios from "axios";
import { getEnvironment } from "../utils/getEnvironment";
import { PeriodSelection } from "../components/Dashboard/Analytics/types";

const environment = getEnvironment();

export interface BestDay {
    label: string;
    revenue: number;
}

export interface RevenueBlock {
    total: number;
    avgPerDay: number;
    avgPerBooking: number;
    bestDayOfWeek: BestDay | null;
}

export interface TimeBlock {
    hoursReceived: number; // minutes
    hoursBlocked: number; // minutes
    availableMinutes: number;
    occupancy: number | null; // real % (can exceed 100)
    avgHourly: number | null;
}

export interface RevenueComparison {
    granularity: "day" | "month";
    labels: string[];
    current: number[];
    previous: (number | null)[];
    currentTotal: number;
    previousTotal: number;
    deltaPct: number | null;
}

export interface ForecastComparison {
    prevRevenue: number;
    revenueDeltaPct: number | null;
    prevBookings: number;
    bookingsDeltaPct: number | null;
}

export type Forecast =
    | { enoughData: false }
    | {
          enoughData: true;
          projectedTotal: number;
          comparison: ForecastComparison | null;
      };

export interface WorkAnalyticsData {
    revenue: RevenueBlock;
    time: TimeBlock;
    comparison: RevenueComparison;
    forecast: Forecast;
}

export default class WorkAnalytics {
    /** Range derived server-side from period + reference date (or from/to). */
    public static readonly info = async (
        uuid: string,
        brand: string,
        location: string,
        selection: PeriodSelection
    ) => {
        const params: Record<string, string> = {
            period: selection.period,
            date: selection.date,
        };
        if (selection.period === "custom") {
            if (selection.from) params.from = selection.from;
            if (selection.to) params.to = selection.to;
        }
        return (await axios
            .get(
                `${environment.api_url}/${brand}/location/${location}/analytics/work-analytics`,
                { headers: { "User-Token": uuid }, params }
            )
            .then((res) => (res.status === 200 ? res.data : undefined))
            .catch(console.error)) as WorkAnalyticsData | undefined;
    };
}
